import { render, staticRenderFns } from "./EditCreate.vue?vue&type=template&id=2ae60046"
import script from "./EditCreate.vue?vue&type=script&lang=js"
export * from "./EditCreate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports